import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader--looped"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "loader--refresh"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Something seems to have gone wrong", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "refresh", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Refresh", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "loader--none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader-wrapper", { 'fill-container': _ctx.fillContainer }])
  }, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.loaderType === 'looped')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : (_ctx.loaderType === 'refresh')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  class: "button is-link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
                }, _hoisted_8)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9))
      ]),
      _: 1
    })
  ], 2))
}